module.exports = __webpack_public_path__ + "static/media/people3.02fc3c01.jpeg";